import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('@/view/login')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/view/404')
    },
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/view/index'),
      redirect: { name: 'home' },
      children: [
        {
          path: '/home',
          name: 'home',
          component: () => import('@/view/home')
        },
        {
          path: '/empty',
          name: 'empty',
          component: () => import('@/view/empty')
        },
        {
          path: '/info',
          name: 'info',
          component: () => import('@/view/info')
        },
        {
          path: '/declareDutiableRecode',
          name: 'declareDutiableRecode',
          meta: {
            isBack: false
          },
          component: () => import('@/view/declareDutiableManage/declareDutiableRecode')
        },
        {
          path: '/incomeAccount',
          name: 'incomeAccount',
          component: () => import('@/view/declareDutiableManage/incomeAccount')
        },
        {
          path: '/endDeclareRecode',
          name: 'endDeclareRecode',
          component: () => import('@/view/declareDutiableManage/endDeclareRecode')
        },
        {
          path: '/endDeclareRecode/lookEndRecode',
          name: 'lookEndRecode',
          component: () => import('@/view/declareDutiableManage/lookEndRecode')
        },
        {
          path: '/declareDutiableRecode/addRecode',
          name: 'addRecode',
          meta: {
            isChange: false
          },
          component: () => import('@/view/declareDutiableManage/addRecode')
        },
        {
          path: '/incomeAccount/importSerial',
          name: 'importSerial',

          component: () => import('@/view/declareDutiableManage/importSerial')
        },
        {
          path: '/incomeAccount/importRecode',
          name: 'importRecode',
          component: () => import('@/view/declareDutiableManage/importRecode')
        },
        {
          path: '/incomeAccount/importRecodeDetail',
          name: 'importRecodeDetail',
          component: () => import('@/view/declareDutiableManage/importRecodeDetail')
        },
        {
          path: '/taxpayerList',
          name: 'taxpayerList',
          component: () => import('@/view/declareDutiablePerson/taxpayerList')
        },
        {
          path: '/taxpayerList/taxpayerListLook',
          name: 'taxpayerListLook',
          component: () => import('@/view/declareDutiablePerson/taxpayerListLook')
        },
        {
          path: '/taxpayerList/taxpayerListAddOrEdit',
          name: 'taxpayerListAddOrEdit',
          component: () => import('@/view/declareDutiablePerson/taxpayerListAddOrEdit')
        },
        {
          path: '/taxpayerApproval',
          name: 'taxpayerApproval',
          component: () => import('@/view/declareDutiablePerson/taxpayerApproval')
        },
        {
          path: '/taxpayerApproval/taxpayerApprovalDeatil',
          name: 'taxpayerApprovalDeatil',
          component: () => import('@/view/declareDutiablePerson/taxpayerApprovalDeatil')
        },
        {
          path: '/taxpayerApproval/fileApproval',
          name: 'fileApproval',
          component: () => import('@/view/declareDutiablePerson/fileApproval')
        },
        {
          path: '/baseInfo',
          name: 'baseInfo',
          component: () => import('@/view/mine/baseInfo')
        },
        {
          path: '/balance',
          name: 'balance',
          component: () => import('@/view/mine/balance')
        },
        {
          path: '/message',
          name: 'message',
          component: () => import('@/view/mine/message')
        },
        {
          path: '/message/detail',
          name: 'messageDetail',
          component: () => import('@/view/mine/messageDetail')
        },
        {
          path: '/securitySettings',
          name: 'securitySettings',
          component: () => import('@/view/mine/securitySettings')
        },
        {
          path: '/statisticalForm',
          name: 'statisticalForm',
          component: () => import('@/view/statisticalForm/statisticalForm')
        },
        {
          path: '/declareStatistiacal',
          name: 'declareStatistiacal',
          component: () => import('@/view/statisticalForm/declareStatistiacal')
        },
        {
          path: '/capitalFlow',
          name: 'capitalFlow',
          component: () => import('@/view/statisticalForm/capitalFlow')
        },
        {
          path: '/accountStatement',
          name: 'accountStatement',
          component: () => import('@/view/statisticalForm/accountStatement')
        },
        {
          path: '/operatorList',
          name: 'operatorList',
          // meta: {
          //   keepAlive: true,
          //   isBack: false
          // },
          component: () => import('@/view/authorityManage/operatorList')
        },
        {
          path: '/operatorList/addOperator',
          name: 'addOperator',
          // meta: {
          //   isChange: false
          // },
          component: () => import('@/view/authorityManage/addOperator')
        },
        {
          path: '/roleList',
          name: 'roleList',
          component: () => import('@/view/authorityManage/roleList')
        },
        {
          path: '/roleList/addRole',
          name: 'addRole',
          component: () => import('@/view/authorityManage/addRole')
        },
        {
          path: '/otherPayOrder',
          name: 'otherPayOrder',
          component: () => import('@/view/otherPayManage/otherPayOrder')
        },
        {
          path: '/otherPayExport',
          name: 'otherPayExport',
          component: () => import('@/view/otherPayManage/otherPayExport')
        },
        {
          path: '/rechargeRecode/toRecharge',
          name: 'toRecharge',
          component: () => import('@/view/otherPayManage/toRecharge')
        },
        {
          path: '/otherPayExport/realImport',
          name: 'realImport',
          component: () => import('@/view/otherPayManage/realImport')
        },
        {
          path: '/rechargeRecode',
          name: 'rechargeRecode',
          component: () => import('@/view/otherPayManage/rechargeRecode')
        },
        {
          path: '/otherPayExport/otherPayExportDeatil',
          name: 'otherPayExportDeatil',
          component: () => import('@/view/otherPayManage/otherPayExportDeatil')
        },
        {
          path: '/otherPayExport/fileUpload',
          name: 'fileUpload',
          component: () => import('@/view/otherPayManage/fileUpload')
        },
        // {
        //   path: '/commercialIndex',
        //   name: 'commercialIndex',
        //   component: () => import('@/view/businessManagement/commercialIndex')
        // },
        {
          path: '/order',
          name: 'orderList',
          component: () => import('@/view/orderManage/list')
        },
        {
          path: '/order/detail',
          name: 'orderDetail',
          component: () => import('@/view/orderManage/detail')
        },
        {
          path: '/order/orderReceiveDetail',
          name: 'orderReceiveDetail',
          component: () => import('@/view/orderManage/orderReceiveDetail')
        },
        {
          path: '/order/modify',
          name: 'modifyOrder',
          component: () => import('@/view/orderManage/modify')
        },
        {
          path: '/orderImport',
          name: 'orderImport',
          component: () => import('@/view/orderImport/importList')
        },
        {
          path: '/orderImport/importDetailed',
          name: 'importDetailed',
          component: () => import('@/view/orderImport/importDetailed')
        },
        {
          path: '/orderImport/fileApproval',
          name: 'order_fileApproval',
          component: () => import('@/view/orderImport/fileApproval')
        },
        {
          path: '/invoiceApply',
          name: 'invoiceApply',
          component: () => import('@/view/invoiceManage/invoiceApply')
        },
        {
          path: '/applyRecode',
          name: 'applyRecode',
          component: () => import('@/view/invoiceManage/applyRecode')
        },
        {
          path: '/applyRecode/invoiceDetail',
          name: 'invoiceDetail',
          component: () => import('@/view/invoiceManage/invoiceDetail')
        },
        {
          path: '/taskSetttings',
          name: 'taskSetting',
          component: () => import('@/view/taskSetting/taskSetttings')
        },
      ]
    }
  ]
})
try {
  const originalPush = Router.prototype.push
  Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
  }
} catch (e) {
}
router.beforeEach((to, from, next) => {
  if (!store.state.token && to.path !== '/') {
    next({ path: '/' })
  } else {
    // 权限控制，判断是否有该页面的权限
    if (to.path !== '/404' && to.path !== '/' && to.path !== '/empty') {
      if (to.path !== '/home') {
        var hasRight
        store.state.aside.forEach(item => {
          if (!item.childMenuList) return false
          item.childMenuList.forEach(e => {
            if (e.path === '/' + to.path.split('/')[1]) {
              hasRight = true
            }
          })
        })
        if (hasRight) {
          next()
        } else {
          next({ path: '/404' })
        }
      } else {
        const hasHomeRight = store.state.aside.some(item => {
          return item.id === '10007'
        })
        if (hasHomeRight) {
          next()
        } else {
          next({ path: '/404' })
        }
      }
    } else {
      next()
    }
  }
})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    location.reload()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js